import { lazy } from "react";
import { GAME_IDS } from "./gameIds";

// PLINKO
const PlinkoGame = lazy(() =>
  import("../games/plinko/GameSection").then(({ PlinkoGame }) => ({ default: PlinkoGame }))
);
const PlinkoBettingSection = lazy(() =>
  import("../games/plinko/BettingSection").then(({ PlinkoBettingSection }) => ({ default: PlinkoBettingSection }))
);
const PlinkoLastRoundResult = lazy(() =>
  import("../games/plinko/LastRoundResult").then(({ PlinkoLastRoundResult }) => ({ default: PlinkoLastRoundResult }))
);

// LIMBO
const LimboGame = lazy(() => import("../games/limbo/GameSection").then(({ LimboGame }) => ({ default: LimboGame })));
const LimboBettingSection = lazy(() =>
  import("../games/limbo/BettingSection").then(({ LimboBettingSection }) => ({ default: LimboBettingSection }))
);
const LimboLastRoundResult = lazy(() =>
  import("../games/limbo/LastRoundResult").then(({ LimboLastRoundResult }) => ({ default: LimboLastRoundResult }))
);

// LIMBO ROCKET
const LimboRocketGame = lazy(() =>
  import("../games/limbo-rocket/GameSection").then(({ LimboRocketGame }) => ({ default: LimboRocketGame }))
);
const LimboRocketBettingSection = lazy(() =>
  import("../games/limbo-rocket/BettingSection").then(({ LimboRocketBettingSection }) => ({
    default: LimboRocketBettingSection,
  }))
);
const LimboRocketLastRoundResult = lazy(() =>
  import("../games/limbo-rocket/LastRoundResult").then(({ LimboRocketLastRoundResult }) => ({
    default: LimboRocketLastRoundResult,
  }))
);

// WHEEL
const WheelGame = lazy(() => import("../games/wheel/GameSection").then(({ WheelGame }) => ({ default: WheelGame })));
const WheelBettingSection = lazy(() =>
  import("../games/wheel/BettingSection").then(({ WheelBettingSection }) => ({ default: WheelBettingSection }))
);
const WheelLastRoundResult = lazy(() =>
  import("../games/wheel/LastRoundResult").then(({ WheelLastRoundResult }) => ({ default: WheelLastRoundResult }))
);

// CHICKEN
const ChickenGame = lazy(() =>
  import("../games/chicken/GameSection").then(({ ChickenGame }) => ({ default: ChickenGame }))
);
const ChickenBettingSection = lazy(() =>
  import("../games/chicken/BettingSection").then(({ ChickenBettingSection }) => ({ default: ChickenBettingSection }))
);
const ChickenLastRoundResult = lazy(() =>
  import("../games/chicken/LastRoundResult").then(({ ChickenLastRoundResult }) => ({ default: ChickenLastRoundResult }))
);

// CHICKEN CHRISTMAS
const ChickenChristmasGame = lazy(() =>
  import("../games/chicken-christmas/GameSection").then(({ ChickenGame }) => ({ default: ChickenGame }))
);
const ChickenChristmasBettingSection = lazy(() =>
  import("../games/chicken-christmas/BettingSection").then(({ ChickenBettingSection }) => ({
    default: ChickenBettingSection,
  }))
);
const ChickenChristmasLastRoundResult = lazy(() =>
  import("../games/chicken-christmas/LastRoundResult").then(({ ChickenLastRoundResult }) => ({
    default: ChickenLastRoundResult,
  }))
);

// CHICKEN WINTER
const ChickenWinterGame = lazy(() =>
  import("../games/chicken-winter/GameSection").then(({ ChickenGame }) => ({ default: ChickenGame }))
);
const ChickenWinterBettingSection = lazy(() =>
  import("../games/chicken-winter/BettingSection").then(({ ChickenBettingSection }) => ({
    default: ChickenBettingSection,
  }))
);
const ChickenWinterLastRoundResult = lazy(() =>
  import("../games/chicken-winter/LastRoundResult").then(({ ChickenLastRoundResult }) => ({
    default: ChickenLastRoundResult,
  }))
);

// MINES
const MinesGame = lazy(() => import("../games/mines/GameSection").then(({ MinesGame }) => ({ default: MinesGame })));
const MinesBettingSection = lazy(() =>
  import("../games/mines/BettingSection").then(({ MinesBettingSection }) => ({ default: MinesBettingSection }))
);
const MinesLastRoundResult = lazy(() =>
  import("../games/mines/LastRoundResult").then(({ MinesLastRoundResult }) => ({ default: MinesLastRoundResult }))
);

// HALLOWEEN MINES
const HalloweenMinesGame = lazy(() =>
  import("../games/halloween-mines/GameSection").then(({ HalloweenMinesGame }) => ({ default: HalloweenMinesGame }))
);
const HalloweenMinesBettingSection = lazy(() =>
  import("../games/halloween-mines/BettingSection").then(({ HalloweenMinesBettingSection }) => ({
    default: HalloweenMinesBettingSection,
  }))
);
const HalloweenMinesLastRoundResult = lazy(() =>
  import("../games/halloween-mines/LastRoundResult").then(({ HalloweenMinesLastRoundResult }) => ({
    default: HalloweenMinesLastRoundResult,
  }))
);

// PLINKO AZTEC
const PlinkoAztecGame = lazy(() =>
  import("../games/plinko-aztec/GameSection").then(({ PlinkoAztecGame }) => ({ default: PlinkoAztecGame }))
);
const PlinkoAztecBettingSection = lazy(() =>
  import("../games/plinko-aztec/BettingSection").then(({ PlinkoAztecBettingSection }) => ({
    default: PlinkoAztecBettingSection,
  }))
);
const PlinkoAztecLastRoundResult = lazy(() =>
  import("../games/plinko-aztec/LastRoundResult").then(({ PlinkoAztecLastRoundResult }) => ({
    default: PlinkoAztecLastRoundResult,
  }))
);

// ROULETTE
const RouletteGame = lazy(() =>
  import("../games/roulette/GameSection").then(({ RouletteGame }) => ({ default: RouletteGame }))
);
const RouletteBettingSection = lazy(() =>
  import("../games/roulette/BettingSection").then(({ RouletteBettingSection }) => ({
    default: RouletteBettingSection,
  }))
);
const RouletteLastRoundResult = lazy(() =>
  import("../games/roulette/LastRoundResult").then(({ RouletteLastRoundResult }) => ({
    default: RouletteLastRoundResult,
  }))
);

// TWIST
const TwistGame = lazy(() => import("../games/twist/GameSection").then(({ TwistGame }) => ({ default: TwistGame })));
const TwistBettingSection = lazy(() =>
  import("../games/twist/BettingSection").then(({ TwistBettingSection }) => ({
    default: TwistBettingSection,
  }))
);
const TwistLastRoundResult = lazy(() =>
  import("../games/twist/LastRoundResult").then(({ TwistLastRoundResult }) => ({
    default: TwistLastRoundResult,
  }))
);

// TWIST CLASSIC
const TwistClassicGame = lazy(() =>
  import("../games/twist-classic/GameSection").then(({ TwistClassicGame }) => ({ default: TwistClassicGame }))
);
const TwistClassicBettingSection = lazy(() =>
  import("../games/twist-classic/BettingSection").then(({ TwistClassicBettingSection }) => ({
    default: TwistClassicBettingSection,
  }))
);
const TwistClassicLastRoundResult = lazy(() =>
  import("../games/twist-classic/LastRoundResult").then(({ TwistClassicLastRoundResult }) => ({
    default: TwistClassicLastRoundResult,
  }))
);

// TOWER CRASH
const TowerCrashGame = lazy(() =>
  import("../games/tower-crash/GameSection").then(({ TowerCrashGame }) => ({ default: TowerCrashGame }))
);
const TowerCrashBettingSection = lazy(() =>
  import("../games/tower-crash/BettingSection").then(({ TowerCrashBettingSection }) => ({
    default: TowerCrashBettingSection,
  }))
);
const TowerCrashLastRoundResult = lazy(() =>
  import("../games/tower-crash/LastRoundResult").then(({ TowerCrashLastRoundResult }) => ({
    default: TowerCrashLastRoundResult,
  }))
);

// CHICKEN MINES
const ChickenMinesGame = lazy(() =>
  import("../games/chicken-mines/GameSection").then(({ ChickenMinesGame }) => ({ default: ChickenMinesGame }))
);
const ChickenMinesBettingSection = lazy(() =>
  import("../games/chicken-mines/BettingSection").then(({ ChickenMinesBettingSection }) => ({
    default: ChickenMinesBettingSection,
  }))
);
const ChickenMinesLastRoundResult = lazy(() =>
  import("../games/chicken-mines/LastRoundResult").then(({ ChickenMinesLastRoundResult }) => ({
    default: ChickenMinesLastRoundResult,
  }))
);

// BALLOON
const BalloonGame = lazy(() =>
  import("../games/balloon/GameSection").then(({ BalloonGame }) => ({ default: BalloonGame }))
);
const BalloonBettingSection = lazy(() =>
  import("../games/balloon/BettingSection").then(({ BalloonBettingSection }) => ({
    default: BalloonBettingSection,
  }))
);
const BalloonLastRoundResult = lazy(() =>
  import("../games/balloon/LastRoundResult").then(({ BalloonLastRoundResult }) => ({
    default: BalloonLastRoundResult,
  }))
);

// CAMEL CRASH
const CamelCrashGame = lazy(() =>
  import("../games/camel-crash/GameSection").then(({ CamelCrashGame }) => ({ default: CamelCrashGame }))
);
const CamelCrashBettingSection = lazy(() =>
  import("../games/camel-crash/BettingSection").then(({ CamelCrashBettingSection }) => ({
    default: CamelCrashBettingSection,
  }))
);
const CamelCrashLastRoundResult = lazy(() =>
  import("../games/camel-crash/LastRoundResult").then(({ CamelCrashLastRoundResult }) => ({
    default: CamelCrashLastRoundResult,
  }))
);

// CONTAINER CRASH
const ContainerCrashGame = lazy(() =>
  import("../games/container-crash/GameSection").then(({ Game }) => ({ default: Game }))
);
const ContainerCrashBettingSection = lazy(() =>
  import("../games/container-crash/BettingSection").then(({ BettingSection }) => ({
    default: BettingSection,
  }))
);
const ContainerCrashLastRoundResult = lazy(() =>
  import("../games/container-crash/LastRoundResult").then(({ LastRoundResult }) => ({
    default: LastRoundResult,
  }))
);

// CHICKEN FOOTBALL
const ChickenFootballGame = lazy(() =>
  import("../games/chicken-football/GameSection").then(({ Game }) => ({ default: Game }))
);
const ChickenFootballBettingSection = lazy(() =>
  import("../games/chicken-football/BettingSection").then(({ BettingSection }) => ({
    default: BettingSection,
  }))
);
const ChickenFootballLastRoundResult = lazy(() =>
  import("../games/chicken-football/LastRoundResult").then(({ LastRoundResult }) => ({
    default: LastRoundResult,
  }))
);

// DICE
const DiceGame = lazy(() => import("../games/dice/GameSection").then(({ Game }) => ({ default: Game })));
const DiceBettingSection = lazy(() =>
  import("../games/dice/BettingSection").then(({ BettingSection }) => ({
    default: BettingSection,
  }))
);
const DiceLastRoundResult = lazy(() =>
  import("../games/dice/LastRoundResult").then(({ LastRoundResult }) => ({
    default: LastRoundResult,
  }))
);

// CANDY CRASH
const CandyTowerGame = lazy(() => import("../games/candy-tower/GameSection").then(({ Game }) => ({ default: Game })));
const CandyTowerBettingSection = lazy(() =>
  import("../games/candy-tower/BettingSection").then(({ BettingSection }) => ({
    default: BettingSection,
  }))
);
const CandyTowerLastRoundResult = lazy(() =>
  import("../games/candy-tower/LastRoundResult").then(({ LastRoundResult }) => ({
    default: LastRoundResult,
  }))
);

// COIN
const CoinGame = lazy(() => import("../games/coin-flip/GameSection").then(({ Game }) => ({ default: Game })));
const CoinBettingSection = lazy(() =>
  import("../games/coin-flip/BettingSection").then(({ BettingSection }) => ({
    default: BettingSection,
  }))
);
const CoinLastRoundResult = lazy(() =>
  import("../games/coin-flip/LastRoundResult").then(({ LastRoundResult }) => ({
    default: LastRoundResult,
  }))
);

export const gameComponentsByGameId = {
  [GAME_IDS.PLINKO]: {
    GameName: "Plinko",
    GameSection: PlinkoGame,
    BettingSection: PlinkoBettingSection,
    LastRoundResult: PlinkoAztecLastRoundResult,
  },
  [GAME_IDS.PLINKO_AZTEC]: {
    GameName: "Plinko Aztec",
    GameSection: PlinkoAztecGame,
    BettingSection: PlinkoAztecBettingSection,
    LastRoundResult: PlinkoAztecLastRoundResult,
  },
  [GAME_IDS.LIMBO]: {
    GameName: "Limbo",
    GameSection: LimboGame,
    BettingSection: LimboBettingSection,
    LastRoundResult: LimboLastRoundResult,
  },
  [GAME_IDS.LIMBO_ROCKET]: {
    GameName: "Limbo Rocket",
    GameSection: LimboRocketGame,
    BettingSection: LimboRocketBettingSection,
    LastRoundResult: LimboRocketLastRoundResult,
  },
  [GAME_IDS.CHICKEN]: {
    GameName: "Chicken",
    GameSection: ChickenGame,
    BettingSection: ChickenBettingSection,
    LastRoundResult: ChickenLastRoundResult,
  },
  [GAME_IDS.CHICKEN_CHRISTMAS]: {
    GameName: "Chicken Christmas",
    GameSection: ChickenChristmasGame,
    BettingSection: ChickenChristmasBettingSection,
    LastRoundResult: ChickenChristmasLastRoundResult,
  },
  [GAME_IDS.CHICKEN_BRANDED]: {
    GameName: "Chicken",
    GameSection: ChickenGame,
    BettingSection: ChickenBettingSection,
    LastRoundResult: ChickenLastRoundResult,
  },
  [GAME_IDS.CHICKEN_WINTER]: {
    GameName: "Chicken Winter",
    GameSection: ChickenWinterGame,
    BettingSection: ChickenWinterBettingSection,
    LastRoundResult: ChickenWinterLastRoundResult,
  },
  [GAME_IDS.WHEEL]: {
    GameName: "Wheel",
    GameSection: WheelGame,
    BettingSection: WheelBettingSection,
    LastRoundResult: WheelLastRoundResult,
  },
  [GAME_IDS.MINES]: {
    GameName: "Mines",
    GameSection: MinesGame,
    BettingSection: MinesBettingSection,
    LastRoundResult: MinesLastRoundResult,
  },
  [GAME_IDS.HALLOWEEN_MINES]: {
    GameName: "Halloween Mines",
    GameSection: HalloweenMinesGame,
    BettingSection: HalloweenMinesBettingSection,
    LastRoundResult: HalloweenMinesLastRoundResult,
  },
  [GAME_IDS.ROULETTE]: {
    GameName: "Roulette",
    GameSection: RouletteGame,
    BettingSection: RouletteBettingSection,
    LastRoundResult: RouletteLastRoundResult,
  },
  [GAME_IDS.TWIST]: {
    GameName: "Twist",
    GameSection: TwistGame,
    BettingSection: TwistBettingSection,
    LastRoundResult: TwistLastRoundResult,
  },
  [GAME_IDS.TWIST_CLASSIC]: {
    GameName: "Twist",
    GameSection: TwistClassicGame,
    BettingSection: TwistClassicBettingSection,
    LastRoundResult: TwistClassicLastRoundResult,
  },
  [GAME_IDS.TOWER_CRASH]: {
    GameName: "Tower Crash",
    GameSection: TowerCrashGame,
    BettingSection: TowerCrashBettingSection,
    LastRoundResult: TowerCrashLastRoundResult,
  },
  [GAME_IDS.CHICKEN_MINES]: {
    GameName: "",
    GameSection: ChickenMinesGame,
    BettingSection: ChickenMinesBettingSection,
    LastRoundResult: ChickenMinesLastRoundResult,
  },
  [GAME_IDS.BALLOON]: {
    GameName: "Balloon",
    GameSection: BalloonGame,
    BettingSection: BalloonBettingSection,
    LastRoundResult: BalloonLastRoundResult,
  },
  [GAME_IDS.CAMEL_CRASH]: {
    GameName: "Camel Crash",
    GameSection: CamelCrashGame,
    BettingSection: CamelCrashBettingSection,
    LastRoundResult: CamelCrashLastRoundResult,
  },
  [GAME_IDS.CONTAINER_CRASH]: {
    GameName: "Container Crash",
    GameSection: ContainerCrashGame,
    BettingSection: ContainerCrashBettingSection,
    LastRoundResult: ContainerCrashLastRoundResult,
  },
  [GAME_IDS.CHICKEN_FOOTBALL]: {
    GameName: "Chicken Football",
    GameSection: ChickenFootballGame,
    BettingSection: ChickenFootballBettingSection,
    LastRoundResult: ChickenFootballLastRoundResult,
  },
  [GAME_IDS.DICE]: {
    GameName: "Dice",
    GameSection: DiceGame,
    BettingSection: DiceBettingSection,
    LastRoundResult: DiceLastRoundResult,
  },
  [GAME_IDS.CANDY_TOWER]: {
    GameName: "Candy Tower",
    GameSection: CandyTowerGame,
    BettingSection: CandyTowerBettingSection,
    LastRoundResult: CandyTowerLastRoundResult,
  },
  [GAME_IDS.COIN_FLIP]: {
    GameName: "Coin",
    GameSection: CoinGame,
    BettingSection: CoinBettingSection,
    LastRoundResult: CoinLastRoundResult,
  },
};
